<template>
  <RequestStatus v-if="!HomeData" :error="failed" @retry="loadHome" />
  <RegistrationClosed v-else-if="!HomeData.Project" :has-ongoing-rating="HomeData.HasOngoingRating === true" />
  <div v-else>
    <Head />

    <div class="wrapper" v-if="HomeData">
      <section class="main">
        <div class="container">
          <ul class="btn_box">
            <li v-if="HomeData.Project && HomeData.Project.IsBefore">
              <button :class="TabIndex == -999 ? 'active' : ''" @click="TabIndex = -999">說明會</button>
            </li>
            <li v-for="EventType in HomeData.EventTypes" :key="EventType.ETId">
              <button :class="EventType.ETId == TabIndex ? 'active' : ''" @click="TabIndex = EventType.ETId">{{
                EventType.Name }}</button>
            </li>
          </ul>
          <ul class="list_box show">
            <li v-if="HomeData.Project && HomeData.Project.IsBefore && TabIndex == -999">
              <a href="javascript:void(0)" @click="gotoBeforeEvent()">
                <div class="img_box">
                  <div class="img">
                    <img v-if="!HomeData.Project.Image" src="img/sample-2.png" alt="">
                    <img v-if="HomeData.Project.Image" :src="HomeData.SiteUrl + HomeData.Project.Image" alt="">
                  </div>
                </div>
                <div class="text">
                  <h1>{{ HomeData.Project.Name }}</h1>
                  <div class="content">
                    <template v-if="HomeData.Project.BeforeStartTime && HomeData.Project.BeforeEndTime">
                      <p>報名期間：{{ HomeData.Project.BeforeStartTime | timeString("YYYY-MM-DD") }} 至 {{
                        HomeData.Project.BeforeEndTime |
                        timeString("YYYY-MM-DD") }}</p>
                    </template>
                    <template v-if="!HomeData.Project.BeforeStartTime && HomeData.Project.BeforeEndTime">
                      <p>報名期間：{{ HomeData.Project.BeforeEndTime | timeString("YYYY-MM-DD") }}截止</p>
                    </template>
                    <template v-if="HomeData.Project.BeforeStartTime && !HomeData.Project.BeforeEndTime">
                      <p>報名期間：{{ HomeData.Project.BeforeStartTime | timeString("YYYY-MM-DD") }}起</p>
                    </template>
                    <template v-if="!HomeData.Project.BeforeStartTime && !HomeData.Project.BeforeEndTime">
                      <p>報名期間：無限制</p>
                    </template>
                    <p style="white-space: pre-line;" v-if="HomeData.Project.BeforeContent">
                      {{ HomeData.Project.BeforeContent }}
                    </p>
                  </div>
                  <div class="btn">我要報名</div>
                </div>
              </a>
            </li>
            <li v-for="Event in HomeData.Events" :key="Event.EId" v-if="Event.ETId == TabIndex">
              <a href="javascript:void(0)" @click="gotoEventByEId(Event.EId)">
                <div class="img_box">
                  <div class="img">
                    <img v-if="!Event.Image" src="img/sample-2.png" alt="">
                    <img v-if="Event.Image" :src="HomeData.SiteUrl + Event.Image" alt="">
                  </div>
                </div>
                <div class="text">
                  <h1>
                    {{ Event.Name }}
                    <div class="apply" v-if="Event.IsEnable">報名中</div>
                    <div class="apply deadline_color" v-else>報名截止</div>
                  </h1>
                  <div class="content">
                    <template v-if="Event.ApplyStartTime && Event.ApplyEndTime">
                      <p>報名期間：{{ Event.ApplyStartTime | timeString("YYYY-MM-DD") }} 至 {{ Event.ApplyEndTime |
                        timeString("YYYY-MM-DD") }}</p>
                    </template>
                    <template v-if="!Event.ApplyStartTime && Event.ApplyEndTime">
                      <p>報名期間：{{ Event.ApplyEndTime | timeString("YYYY-MM-DD") }}截止</p>
                    </template>
                    <template v-if="Event.ApplyStartTime && !Event.ApplyEndTime">
                      <p>報名期間：{{ Event.ApplyStartTime | timeString("YYYY-MM-DD") }}起</p>
                    </template>
                    <template v-if="!Event.ApplyStartTime && !Event.ApplyEndTime">
                      <p>報名期間：無限制</p>
                    </template>
                    <p style="white-space: pre-line;" v-if="Event.SimpleContent">
                      {{ Event.SimpleContent }}
                    </p>
                  </div>
                  <div class="btn">MORE</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import RequestStatus from "@/components/RequestStatus.vue";
import RegistrationClosed from "@/components/RegistrationClosed.vue";
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


export default {
  name: "Home",
  components: {
    Head,
    RequestStatus,
    RegistrationClosed,
    Footer,
  },
  data() {
    return {
      HomeData: null,
      failed: false,
      requestId: 0,
      TabIndex: 0,
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.loadHome();
    next();
  },
  created() { this.loadHome(); },
  beforeDestroy() { this.requestId++; },
  mounted: function () {
  },
  updated: function () {
  },
  methods: {
    async loadHome() {
      const requestId = ++this.requestId;
      this.HomeData = null;
      this.failed = false;
      try {
        const { data } = await axios.get(
          this.$store.state.src + this.$store.state.subDirectory + "/Html/Home",
          { params: {
            lang: this.$cookies.get("is_site_lang"),
            token: this.$cookies.get("is_login_token"),
          }, timeout: 15000 }
        );
        if (requestId !== this.requestId) return;
        if (!data || !Object.prototype.hasOwnProperty.call(data, 'Project')) {
          throw new Error('Invalid home response');
        }
        if (data.User && data.User.IsReviewer) {
          await this.$router.replace({ name: "RatingHome" });
          return;
        }
        this.HomeData = data;
        this.TabIndex = data.DefaultETId;
      } catch (error) {
        if (requestId === this.requestId) this.failed = true;
      }
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId },
        });
      }
    },
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoPostByPId: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoEventByEId: function (EId) {
      this.$router.push({
        name: "Event",
        params: { EId: EId },
      });
    },
    gotoBeforeEvent: function () {
      this.$router.push({
        name: "BeforeEvent",
        //params: { EId: EId },
      });
    },
  },
};
</script>
